import { Button, buttonClasses } from '@mui/material';
import React, { useCallback } from 'react';
import { DeepPartial, useFormContext, useWatch } from 'react-hook-form';

interface Props<T extends string> {
  valuesResetTo: DeepPartial<Record<T, any>>;
  onClick: () => void;
}

export const ClearButton = <T extends string>({
  valuesResetTo,
  onClick,
}: Props<T>) => {
  const { reset } = useFormContext();
  const watchedFields = useWatch();

  const countFilledFields = Object.values(watchedFields).filter(
    (value) => value,
  ).length;

  const handleResetValues = useCallback(() => {
    reset(valuesResetTo);
    onClick();
  }, [valuesResetTo, reset, onClick]);

  return (
    <Button
      variant="text"
      size="small"
      disabled={!countFilledFields}
      onClick={handleResetValues}
      sx={{
        whiteSpace: 'nowrap',
        textDecoration: 'underline',
        textTransform: 'none',
        [`&:hover .${buttonClasses.startIcon}`]: {
          transform: 'rotateZ(-90deg)',
        },
      }}
    >
      נקה סינונים
    </Button>
  );
};
